import { render, staticRenderFns } from "./VueCsvImport.vue?vue&type=template&id=37f8ab8d&"
import script from "./VueCsvImport.vue?vue&type=script&lang=js&"
export * from "./VueCsvImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports